/**
 * @file   src\utils\PageUrls.ts
 * @brief  URL's page.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

export const pageURLs = Object.freeze({
    root: '/',
    signup: 'signup',
    product_signup: 'subscribe',
    product_signup_car_info: 'carinfo',
    statussuccess: 'status-success',
    statusbusy: 'status-busy',
    scannerque: 'scanner-que',
    statusoutofservice: 'status-outofservice',
    home: 'home',
    qrscanner: 'qr-scanner',
    locations: 'locations',
    location_switch: 'location-switch',
    subscriptionandwashprice: 'subscription-and-washprice',
    selfServeSubscriptionandwashprice:'self-service-subscription-and-washprice',
    signupsubscriptionandwashpricelist: 'signup-subscription-and-washprice-list',
    payment: 'payment',
    update_payment: 'update-payment',
    settings: 'settings',
    contactus: 'contactus',
    my_subscriptions: 'my-subscriptions',
    my_wallet: 'my-wallet',
    buy_gift_card: 'buy-gift-card',
    gift_card_payment: 'gift-card-payment',
    myprofile: "myprofile",
    promotions: "promotions",
    advertisement: "advertisement",
    refer_friend: "refer-friend",
    refer_family: "refer-family",
    buysubscription: "buy-subscription",
    notifications: "notifications", 
    error: "error", 
    selectwash: "select-wash",
    signin: 'signin',
    unsubscribe:'unsubscribe',
    selectBayType: 'select-bay-type',
    selfService: 'self-service',
    SelfServeSelectwash: 'self-serve-select-wash',
    car_info:'car-info',
    signuo_car_info:'signup-carinfo',
    buyups: 'buy-ups'
});
